import { makeStyles } from '@material-ui/core'
import { GRAY_COLORS, PRIMARY_COLORS } from '../../../../asterX-UI'

export const useRopStyles = makeStyles(() => ({
  pagination: {
    '& .MuiPaginationItem-root': {
      margin: 0
    },
    '& .MuiPagination-ul li:first-child button': {
      borderTopRightRadius: 0,
      borderBottomRightRadius: 0,
      borderRight: 0
    },
    '& .MuiPagination-ul li:last-child button': {
      borderTopLeftRadius: 0,
      borderBottomLeftRadius: 0,
      borderLeft: 0
    },
    '& .MuiPagination-ul li:not(:last-child):not(:first-child) button': {
      borderRadius: 0
    }
  },
  wlTable: {
    backgroundColor: 'white',
    borderRadius: 12,
    border: `1px solid ${GRAY_COLORS[200]}`,
    overflow: 'hidden'
  },
  filterTabs: {
    padding: '12px 0',
    overflow: 'auto',
    borderBottom: `1px solid ${GRAY_COLORS[200]}`,
    '&::-webkit-scrollbar': {
      display: 'none!important'
    }
  },
  tabsScroll: {
    minWidth: 420
  },
  tableStatusBtn: {
    padding: '8px 12px',
    fontSize: 14,
    fontWeight: 600,
    color: GRAY_COLORS[500]
  },
  tableStatusBtnActive: {
    color: `${PRIMARY_COLORS[700]} !important`,
    backgroundColor: `${PRIMARY_COLORS[50]} !important`
  },
  tableStatusCount: {
    display: 'flex',
    height: 22,
    borderRadius: 16,
    padding: '2px 8px',
    fontSize: 12,
    fontWeight: 500,
    color: PRIMARY_COLORS[700],
    backgroundColor: PRIMARY_COLORS[100]
  },
  customizedCheckbox: {
    padding: 0,
    margin: 0,
    border: 0,
    fontSize: 12
  },
  discountTabs: {
    '& .Mui-selected': {
      color: PRIMARY_COLORS[700]
    },
    '& .MuiTabs-indicator': {
      backgroundColor: PRIMARY_COLORS[700]
    }
  }
}))
